import {
    Gender,
    EducationAction,
    EducationLevel,
    PreschoolAgeLevel,
    SpecialEducationRequirements,
    DisabilityGroup,
    DisabilityReason
} from 'src/constants';
import { EducationLevelGroupData } from 'src/constants/children/form';

export type Parent = {
    taxNumber: string;
    name: string;
    surname: string;
    patronymic: string;
    email: string;
    phone: string;
};

export class Child {
    constructor(
        public id: number,
        public lastName: string,
        public firstName: string,
        public birthDate: string,
        public gender: Gender,
        public visit: ChildVisit,
        public visitHistory: ChildVisit[] = [],
        public patronymic?: string
    ) {}

    static validate(child: Child) {
        this.checkSpecialRequirementsParam(child);
    }

    static checkSpecialRequirementsParam(child: Child) {
        const specialRequirements = child?.visit?.specialRequirements;
        const otherSpecialRequirements = child?.visit?.otherSpecialRequirements;

        if (specialRequirements) {
            if (otherSpecialRequirements) {
                specialRequirements.parameters.push(SpecialEducationRequirements.OTHER);
            }

            if (specialRequirements.enabled && specialRequirements.parameters.length === 0) {
                specialRequirements.enabled = false;
                specialRequirements.parameters = [];
            }
        }
    }
}

export interface VisitParents {
    parent: Parent;
    role: string;
    active: boolean;
    id: number | null;
}

export type ChildVisit = {
    id: number | null;
    version: number | null;
    actualAddress: string;
    registrationAddress: string;
    educationInstitutionUrl: string;
    educationInstitutionPhone: string;
    educationInstitutionEmail?: string;
    additionalActionRequired: {
        enabled: boolean;
        action?: EducationAction;
    };
    visitParents: VisitParents[];
    educationLevel: EducationLevel | null;
    // educationLevelGroup added on UI side (you'll not see this in response)
    educationLevelGroup?: EducationLevelGroupData | null;
    academicHoursCount?: number;
    preschoolAgeLevel?: PreschoolAgeLevel;
    educationCenterId: number | null;
    educationCenter?: any;
    hospital?: any;
    hospitalId: number | null;
    hospitalDepartmentId: number | null;
    hospitalDepartment?: any;
    servicesAgreementDate: string;
    servicesEndDate?: string | null;
    specialRequirements: {
        enabled: boolean;
        parameters: SpecialEducationRequirements[];
    };
    otherSpecialRequirements?: string;
    disabilityPresent: boolean;
    disabilityGroup?: DisabilityGroup;
    disabilityReason?: DisabilityReason;
    orphan: boolean;
    internallyDisplaced: boolean;
    warVictim: boolean;
    complicatedLifeCircumstances: boolean;
    otherSocialStatus: string;
    mediaRecordingAgreement: boolean;
    mediaRecordingLink: string;
    info: Text | null;
};
